import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import logo from 'images/logo'
import { showMobileStartAction, updateCurrentEntityAction, checkOfflineLimitsAction } from 'actions/applicationActions'
import { updateUiAction } from 'actions/uiActions'
import { zoomToAllDevicesAction, updateMapTypeAction } from 'actions/mapActions'
import { cancelScaleFloorPlanAction } from 'actions/floorPlanActions'
import getCurrentCamera from 'helpers/cameras/getCurrentCamera'
import { ROADMAP, SATELLITE, BLANK } from 'helpers/globals'
import mapView from 'assets/images/mapTypes/mapView.png'
import satelliteView from 'assets/images/mapTypes/satelliteView.jpg'

const mapStateToProps = ({ permalink, messages, cameras, currentEntity, ui: { scaling }, map: { mapType } }) => {
  const currentCamera = getCurrentCamera(cameras)
  return {
    permalink,
    messages,
    cameraSelected: currentCamera && currentEntity.type === 'camera' && currentEntity.id === currentCamera.id,
    currentEntity,
    scaling,
    mapType
  }
}

const isAutosaveMsg = msg => msg === 'Saved' || msg === 'Saving...'
const fullscreenAvailable = document.fullscreenEnabled

class MobileTopBar extends React.Component {
  state = { fullscreen: fullscreenAvailable && document.fullscreenElement, optionsOpen: false }

  componentDidMount = _ => {
    document.onfullscreenchange = _ => {
      this.setState({ fullscreen: document.fullscreenElement })
    }
    window.addEventListener('click', this.windowClick)
  }

  componentWillUnmount = _ => {
    document.onfullscreenchange = null
    window.removeEventListener('click', this.windowClick)
  }

  windowClick = event => {
    if (this.state.optionsOpen) {
      if (this.refs.optionsButton.contains(event.target)) return
      this.setState({ optionsOpen: false })
    }
  }

  toggleFullscreen = _ => {
    if (document.fullscreenElement) document.exitFullscreen().then(this.setState({ fullscreen: false }))
    else document.documentElement.requestFullscreen().then(this.setState({ fullscreen: true }))
  }

  handleClick = _ => {
    const { cameraList, scaling, cameraSelected, menuSelected, close, updateCurrentEntityAction, showMobileStartAction,
      updateUiAction, cancelScaleFloorPlanAction, currentEntity } = this.props

    if (cameraList) {
      updateCurrentEntityAction({ type: 'map' })
      return close()
    } else if (scaling) {
      cancelScaleFloorPlanAction()
      return close()
    }

    if (cameraSelected && menuSelected) return close()
    if (currentEntity.type === 'map') {
      showMobileStartAction()
      return updateUiAction({ mapLoaded: false })
    }

    updateCurrentEntityAction({ type: 'map' })
    close()
  }

  backButtonText = _ => {
    const { cameraList, scaling, cameraSelected, menuSelected, currentEntity } = this.props

    if (cameraList) return 'Back'
    if (scaling) return 'Cancel'
    if (cameraSelected && menuSelected) return 'Camera'
    if (currentEntity.type === 'map') return 'Projects'

    return 'Map'
  }

  render() {
    const { toggleFullscreen, handleClick, backButtonText, state: { fullscreen, optionsOpen }, props: { permalink, messages,
      openCameraList, mapType, checkOfflineLimitsAction, updateUiAction, zoomToAllDevicesAction, updateMapTypeAction, classes } } = this

    return (
      <div className={classes.topBar}>
        <div className={classes.backLink} onClick={handleClick}>
          <FontAwesomeIcon icon='chevron-left' className={classes.backButton} />
          { backButtonText() }
        </div>
        <div className={classes.centerContainer}>
          <img src={logo} alt='IPVM Logo' className={classes.logo} />
          { !permalink && !!messages && isAutosaveMsg(messages.saveState) && (
              messages.saveState === 'Saved'
              ? <div>
                  <FontAwesomeIcon icon='save' className={classes.saveIcon} />
                  <FontAwesomeIcon icon='check' className={classes.checkIcon} />
                </div>
              : <div>
                  <FontAwesomeIcon icon='save' className={classes.saveIcon} />
                  <FontAwesomeIcon icon='spinner' className={`${classes.spinner} fa-spin`} />
                </div>
            )
          }
        </div>
        <div className={classes.rightContainer}>
          <div className={classes.backLink} onClick={_ => this.setState({ optionsOpen: !optionsOpen })} ref='optionsButton'>
            Options
            { optionsOpen ? <FontAwesomeIcon icon='caret-up' className={classes.caretIcon} /> : <FontAwesomeIcon icon='caret-down' className={classes.caretIcon} /> }
          </div>
          {
            optionsOpen &&
            <div className={classes.optionsMenu}>
              <div onClick={updateUiAction.bind(null, { modal: 'EditProjectTitle' })}>
                <FontAwesomeIcon icon='pen' className={classes.icon} />
                <span>Rename Project</span>
              </div>
              <div onClick={openCameraList}>
                <FontAwesomeIcon icon='clipboard-list' className={classes.icon} />
                <span>Project Items</span>
              </div>
              <div onClick={_ => checkOfflineLimitsAction('modal', ['Permalink'])}>
                <FontAwesomeIcon icon='link' className={classes.icon} />
                <span>Share Project</span>
              </div>
              <div onClick={_ => zoomToAllDevicesAction()}>
                <FontAwesomeIcon icon={['far', 'eye']} className={classes.icon} />
                <span>View All Cameras</span>
              </div>
              {
                fullscreenAvailable &&
                <div onClick={toggleFullscreen}>
                  { fullscreen ? <FontAwesomeIcon icon='compress' className={classes.icon} /> : <FontAwesomeIcon icon='expand' className={classes.icon} /> }
                  <span>Fullscreen</span>
                </div>
              }
              <div className={classes.mapTypesContainer} style={{ alignItems: 'flex-start' }}>
                <span>Map type:</span>
                <div className={mapType === SATELLITE ? classes.mapButtonCurrent : classes.mapButton} onClick={_ => updateMapTypeAction(SATELLITE)}>
                  <img src={satelliteView} className={classes.icon} />
                  <span>Satellite</span>
                </div>
                <div className={mapType === ROADMAP ? classes.mapButtonCurrent : classes.mapButton} onClick={_ => updateMapTypeAction(ROADMAP)}>
                  <img src={mapView} className={classes.icon} />
                  <span>Roadmap</span>
                </div>
                <div className={mapType === BLANK ? classes.mapButtonCurrent : classes.mapButton} onClick={_ => updateMapTypeAction(BLANK)}>
                  <div className={classes.blankView} />
                  <span>Blank</span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { showMobileStartAction, updateCurrentEntityAction, checkOfflineLimitsAction,
  updateUiAction, zoomToAllDevicesAction, cancelScaleFloorPlanAction, updateMapTypeAction })(injectSheet(style)(MobileTopBar))



// WEBPACK FOOTER //
// ./src/components/MobileTopBar/index.js